import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, from, takeUntil } from 'rxjs';
import { GspLoggerService } from 'src/app/log-handler.service';

@Component({
    selector: 'load-img',
    template: `
        <a [href]="imageUrl" target="_blank" rel="noopener noreferrer" (click)="$event.preventDefault()">
            <img
                [src]="imageToShow"
                [class.disabled-context-menu]="thumbnailImageUrl?.length"
                *ngIf="!isImageLoading && showOnCondition && imageToShow; else noImageFound"
                class="actual-img {{ appendClass }}"
                (change)="changeListener($event)"
            />
        </a>

        <ng-template #noImageFound>
            <img
                *ngIf="fallbackImageUrl"
                class="{{ appendClass }}"
                [src]="fallbackImageUrl"
                (change)="changeListener($event)"
            />
        </ng-template>
    `
})
export class LoadImageComponent implements OnInit, OnDestroy {
    @Input()
    public fallbackImageUrl: string;

    @Input()
    public showOnCondition: boolean;

    @Input()
    public imageUrl: string;

    @Input()
    public thumbnailImageUrl: string = '';

    @Input()
    public appendClass: boolean;

    @Input()
    public authenticate: boolean;

    public isImageLoading = true;

    public imageToShow: string | ArrayBuffer;

    private destroy = new Subject();

    constructor(private httpClient: HttpClient, private logger: GspLoggerService) {}

    ngOnInit() {
        this.loadImage();
    }

    ngOnDestroy() {
        this.destroy.next(null);
    }

    public loadImage(): void {
        if (this.showOnCondition && this.imageUrl) {
            let image = this.thumbnailImageUrl || this.imageUrl;

            this.isImageLoading = true;

            if (this.authenticate) {
                this.imageUrl = '#'; // Disable hyperlink.
                from(this.getImage(image))
                    .pipe(takeUntil(this.destroy))
                    .subscribe(
                        data => {
                            this.createImageFromBlob(data);
                            this.isImageLoading = false;
                        },
                        error => {
                            this.logger.error(error);
                            this.isImageLoading = false;
                        }
                    );
            } else {
                this.imageToShow = image;
                this.isImageLoading = false;
            }
        }
    }

    getImage(imageUrl: string): Observable<Blob> {
        return this.httpClient.get(imageUrl, { responseType: 'blob' });
    }

    createImageFromBlob(image: Blob): void {
        let reader = new FileReader();
        reader.addEventListener(
            'load',
            () => {
                // returns base64 encoded string
                this.imageToShow = reader.result;
            },
            false
        );

        if (image) {
            reader.readAsDataURL(image);
        }
    }
}
